import { render, staticRenderFns } from "./BookingConfigPane.vue?vue&type=template&id=3a457850&scoped=true"
import script from "./BookingConfigPane.vue?vue&type=script&lang=js"
export * from "./BookingConfigPane.vue?vue&type=script&lang=js"
import style0 from "./BookingConfigPane.vue?vue&type=style&index=0&id=3a457850&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a457850",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a457850')) {
      api.createRecord('3a457850', component.options)
    } else {
      api.reload('3a457850', component.options)
    }
    module.hot.accept("./BookingConfigPane.vue?vue&type=template&id=3a457850&scoped=true", function () {
      api.rerender('3a457850', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods_activity/booking/BookingConfigPane.vue"
export default component.exports